var globalFunctions = {
    checkVisible () {
        return parseInt(  window.localStorage.getItem('role_id') ) < 4;
    }
}
export default globalFunctions